import styled from "styled-components";

export const StyledSection = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 0;

  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }

  > div:first-child {
    flex-basis: 40%;
    padding-right: 29px;

    > h6 {
      color: ${({ theme }) => theme.colors.neutralsText};
      font-family: Roboto;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0.18px;
      margin: 0 0 16px;
      word-break: break-word;
      white-space: break-spaces;

      > span {
        color: ${({ theme }) => theme.colors.neutralsTextLight};
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0.14px;
        word-break: break-word;
        white-space: break-spaces;
        display: block;
      }
    }

    > p {
      color: ${({ theme }) => theme.colors.neutralsTextLight};
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      margin: 16px 0 6px;
      word-break: break-word;
      white-space: break-spaces;
    }
  }

  > div:last-child {
    flex-basis: 60%;
    padding-left: 29px;
  }
`;
